/** @format */

export enum ProductPageTemplateType {
  BUNDLE = 'Bundle',
  OUT_OF_STOCK = 'OutOfStock',
  STANDARD = 'Standard',
}
